export var RadioKeyConstants = {
    enterKey: 'Enter',
};
